<template>
  <v-dialog scrollable persistent :modelValue="orderListDialog" maxWidth="640">
    <v-card>
      <v-card-title class="headline"> Specify order of prompts within this placement </v-card-title>
      <v-card-text class="promotion-priority-div">
        <div class="list-group-header">
          <div class="promotion-priority-col-0">
            <span></span>
          </div>
          <div class="promotion-priority-col-1">
            <span>Order</span>
          </div>
          <div class="promotion-priority-col-2 flex justify-between">
            <span>Prompt</span>
            <v-checkbox
              v-model="removeEnded"
              class="mt-0 mr-0 pt-0"
              label="Active prompts only"
              dark
              density="compact"
              hideDetails
            ></v-checkbox>
          </div>
        </div>
        <draggable
          v-model="orderedPaths"
          itemKey="id"
          :animation="150"
          :componentData="{ name: 'flip-list', tag: 'div', type: 'transition' }"
          v-bind="dragOptions"
          class="priority-list-wrapper"
          @start="isDragging = true"
          @end="isDragging = false"
        >
          <template #item="{ element, index }">
            <span
              v-if="!removeEnded || (element.is_enabled && !isPromptExpired(element.end_date))"
              :key="element.id"
              class="list-group-item"
            >
              <span class="promotion-priority-col-0">
                <v-icon size="small">md:drag_indicator</v-icon>
              </span>
              <span class="promotion-priority-col-1">
                <span>{{ index + 1 }}</span>
              </span>
              <span class="promotion-priority-col-2">
                <span @click="showRetention(element)">{{ element.name }}</span>
              </span>
            </span>
          </template>
        </draggable>
      </v-card-text>
      <v-card-actions class="modal-card-actions-div">
        <v-btn
          size="large"
          class="cancel-btn"
          variant="outlined"
          style="width: 100px"
          @click="$emit('closeOrderListDialog')"
          >Close</v-btn
        >
        <v-btn
          size="large"
          variant="flat"
          color="primary"
          style="width: 170px"
          @click="updateOrderListClick"
        >
          <v-icon start>md:save</v-icon>Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import draggable from "vuedraggable";
import { cloneDeep } from "lodash-es";
import { useToastsStore } from "@/pinia/toastsStore";
import { useAllPromptsStore } from "@/pinia/allPromptsStore";
import { useAppsStore } from "@/pinia/appsStore";

export default {
  name: "RfPlacementsOrder",
  components: { draggable },
  props: ["retentions", "orderListDialog", "currRetention"],
  setup: () => ({
    toastsStore: useToastsStore(),
    allPromptsStore: useAllPromptsStore(),
    appsStore: useAppsStore(),
  }),
  data: () => ({ currentRetentions: [], removeEnded: false }),
  computed: {
    currApp() {
      return this.appsStore.app;
    },
    orderedPaths: {
      get() {
        return this.removeEnded
          ? [...this.currentRetentions].sort((a, b) => {
              const aEnabled = a.is_enabled && !this.isPromptExpired(a.end_date);
              const bEnabled = b.is_enabled && !this.isPromptExpired(b.end_date);
              if (aEnabled === bEnabled) return 0;
              return aEnabled ? -1 : 1;
            })
          : this.currentRetentions;
      },
      set(value) {
        this.currentRetentions = value.map((item, index) => ({ ...item, order: index }));
      },
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  watch: {
    orderListDialog(v) {
      this.currentRetentions = v
        ? (cloneDeep(this.retentions) || []).sort((a, b) => a.order - b.order)
        : (this.currentRetentions = []);
    },
  },
  methods: {
    showRetention(retention) {
      this.$emit("closeOrderListDialog");
      this.$router.push({
        path: `/apps/${this.$route.params.aid}/retentions/${retention.id}`,
      });
    },
    async updateOrderListClick() {
      try {
        await this.allPromptsStore.setOrderRetentions({
          appId: this.currApp.id,
          paths: this.currentRetentions,
        });
        this.$emit("closeOrderListDialog");
        this.$forceUpdate();
      } catch (error) {
        this.toastsStore.create({ type: "error", body: `${error}. Please try again.` });
      }
    },
    isPromptExpired: endDate => +new Date(endDate) < +new Date(),
  },
};
</script>
